<template>
  <div class="grid-x">
    <div ref="infoBox" class="small-12 siteMonetization margin-bottom-xs">
      <div class="product-pool-media-container sponsoredProductsRedesign">
        <div v-if="sponsoredLoading">
          <AtomicUiSkeleton class="skeletonColor" width="100%" />
        </div>
        <div v-else>
          <div class="poolHeader padding-top-s margin-bottom-s">
            <span>Sponsored Items</span>
          </div>
          <div v-if="productPoolMedia" id="productItems" class="product-pool-media product-pool-media-carousel">
            <AtomicUiCarousel :list="productPoolMedia" :number-of-items="{ large: 5, medium: 5, small: 2.5 }" @carousel-next="carousalNext()">
              <template #item="slotProps">
                <div class="cell siteMonetizationBrowseAndSearch">
                  <div class="grid-x productThumbnail redesignEnabled">
                    <div class="cell small-12 productThumbnailImage">
                      <a
                        :href="slotProps.data.identifier.productUrl"
                        @click.prevent="showProductBecon(slotProps.data.id, slotProps.data.identifier.productUrl)"
                      >
                        <img :alt="slotProps.data.name" :src="addExtensionIfNeeded(`${imageHost}/${slotProps.data.imagery}`)" />
                      </a>
                    </div>

                    <div class="grid-y small-12 productDetail">
                      <div class="productDescription">
                        <a :href="slotProps.data.identifier.productUrl">
                          <div class="productBrand">
                            {{ slotProps.data.brand }}
                          </div>
                          <div class="prodDescription">
                            {{ slotProps.data.name }}
                          </div>
                        </a>
                        <div class="priceInfo">
                          <div class="prices">
                            <div>
                              <span class="regular originalOrRegularPriceOnSales" :class="slotProps.data.formatedSale ? 'priceLabelStrike' : ''">
                                <span class="priceLabel" :class="{ boldClass: true }">
                                  {{ slotProps.data.formatedPrice }}
                                </span>
                              </span>
                            </div>
                            <div v-if="slotProps.data.formatedSale">
                              <span class="discount">
                                <span class="priceLabel">Sale</span>
                                {{ slotProps.data.formatedSale }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-if="slotProps.data.pricing.badges">
                          <div v-for="item in slotProps.data.pricing.badges" :key="item.promoId">
                            <span v-if="item.finalPrice" class="offer" :class="{ boldClass: true }"
                              >With offer {{ item.finalPrice.values[0].formattedValue }}</span
                            >
                            <span>{{ item.header }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </AtomicUiCarousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useSponsoredItemsStore } from '~/stores/sponsoredItems'; // Assuming this is the path to your store

//---Local state---//
const imageHost = ref('https://slimages.macysassets.com/is/image/MCY/products');
//const viewdProductId = ref([]);
const nextCount = ref(1);
const apiCount = ref(0);

const sponsoredItemsStore = useSponsoredItemsStore();
const productPoolMedia = computed(() => sponsoredItemsStore.productPoolMedia);
const sponsoredLoading = computed(() => sponsoredItemsStore.sponsoredLoading);

//---methods---//
const generatetUid = () => {
  return String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
};
const checkVisible = (elm) => {
  const rect = elm.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
};
const invokeBeconProductsView = (beconProducts) => {
  if (beconProducts.length > 0) {
    beconProducts.forEach((el) => {
      const url = el.meta.productSMData.onViewBeacon;
      sponsoredItemsStore.invokeUrl(url);
    });
    return true;
  }
  return false;
};
const someFunc = () => {
  if (!document.getElementById('productItems')) {
    return;
  }
  const sponsoredItemsEl = document.getElementById('productItems');
  const ifVisible = checkVisible(sponsoredItemsEl);

  if (ifVisible) {
    let beconProducts = [...productPoolMedia.value];
    if (beconProducts.length > 0) {
      beconProducts = beconProducts.slice(nextCount.value - 1, nextCount.value * 5);
      invokeBeconProductsView(beconProducts);
    }
    window.removeEventListener('scroll', someFunc);
  }
};
const showProductBecon = (id, productUrl) => {
  if (id !== '') {
    const metaData = productPoolMedia?.value?.filter((el) => el.id === id);
    if (metaData && metaData.length > 0) {
      const url = metaData[0].meta.productSMData.onClickBeacon;

      if (url) {
        sponsoredItemsStore.invokeUrl(url);
        window.location.href = productUrl; // url;
        return true;
      }
    }
  }
  return false;
};
const carousalNext = () => {
  nextCount.value++;
  let beconProducts = [...productPoolMedia.value];
  beconProducts = beconProducts.slice((nextCount.value - 1) * 5, nextCount.value * 5);
  invokeBeconProductsView(beconProducts);
};

const handleScroll = async () => {
  const customerId = useCookie('macys_online_uid').value;
  const deviceType = 'desktop';
  const category = 'dealspage';
  const sponosoredItemsFilter = 'ALL';
  const regionCode = 'US';
  //const rem = document.body.offsetHeight - (document.body.offsetHeight * 4) / 100;
  if (window.scrollY >= 300) {
    apiCount.value++;
    const uid = generatetUid();
    if (productPoolMedia?.value?.length > 0) {
      return false;
    }
    if (apiCount.value > 1) {
      return false;
    }
    await sponsoredItemsStore.fetchSponsoredItems({
      customerId,
      deviceType,
      category,
      sponosoredItemsFilter,
      regionCode,
      uid,
      apiCount: apiCount.value,
    });
    window.removeEventListener('scroll', handleScroll);
  }
};
const addExtensionIfNeeded = (str) => {
  let val = str;
  if (!val.endsWith('.tif')) {
    val += '.tif';
  }
  return val;
};

//----lifecycle hooks----//
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('scroll', someFunc);
});
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('scroll', someFunc);
});
</script>

<style lang="scss" brand="mcom" scoped>
.siteMonetization {
  background-color: $white;
  min-height: rem-calc(5);
  padding: rem-calc(0 0 25 25);
}

.product-pool-media-container.sponsoredProductsRedesign {
  height: auto;
  background-color: $white;

  .poolHeader {
    text-transform: capitalize;
    font-weight: 700;
    font-size: rem-calc(18);
    margin: auto;
  }
}

.product-pool-media-container .product-pool-media-carousel {
  height: 80%;

  ul li {
    max-width: rem-calc(310);
    list-style-type: none;
    position: relative;
    padding: rem-calc(0 1.5 0 0);
  }
}

.product-pool-media-container .productThumbnail {
  position: relative;
  text-align: center;

  .productThumbnailImage {
    height: auto;
    position: relative;
  }

  .productDetail {
    text-align: left;
    margin-left: rem-calc(20);

    .productDescription {
      margin-top: rem-calc(1);

      .productBrand {
        padding-bottom: rem-calc(0.125);
        font-weight: 700;
      }

      .prodDescription {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .priceInfo .prices {
        div {
          padding-top: rem-calc(0.125);
        }

        div:first-child {
          padding-top: 0;
        }

        .originalOrRegularPriceOnSales {
          font-weight: 400;
        }

        .priceLabelStrike {
          text-decoration: line-through;
        }

        span.priceLabel {
          color: $black;
        }

        .discount {
          color: $primary-color;
        }
      }

      .badges {
        padding-top: rem-calc(0.625);

        .badge:first-child {
          padding-top: 0;
        }

        .badge .regularPromotion {
          color: $black;
        }
      }
    }
  }
}

.boldClass {
  font-weight: 700;
}

a {
  text-decoration: none;
}

a:focus,
a:hover {
  color: $black;
  text-decoration: underline;
}

.skeletonColor {
  background: $white;
}

@media only screen and (max-width: rem-calc(400)) {
  .product-pool-media-container .product-pool-media-carousel {
    width: rem-calc(285);
    overflow: hidden;
  }
}

.offer {
  color: $primary-color;
}
</style>
